class EnvironmentService {
  isProduction(): boolean {
    return process.env.NODE_ENV !== 'development';
  }
}

export default new EnvironmentService();